const MAP = {
  trifit: { label: "Trifit", short: "T", cls: "text-sky-700 border-sky-300 bg-sky-50", tip: "From the athlete's Trifit phone app" },
  wearable: { label: "Wearable", short: "W", cls: "text-emerald-700 border-emerald-300 bg-emerald-50", tip: "From a connected wearable (via OpenWearables)" },
  model: { label: "Model", short: "M", cls: "text-neutral-600 border-neutral-300 bg-neutral-50", tip: "Computed by the Trifit.XPS model" },
};

export function ProvenanceBadge({ source, showLabel = false }) {
  const m = MAP[source];
  if (!m) return null;
  return (
    <span
      title={`Source: ${m.label} · ${m.tip}`}
      data-testid={`prov-${source}`}
      className={`inline-flex items-center justify-center text-[9px] font-bold uppercase tracking-wider border rounded-sm leading-none ${showLabel ? "px-1.5 py-0.5" : "w-3.5 h-3.5"} ${m.cls}`}
    >
      {showLabel ? m.label : m.short}
    </span>
  );
}

export function ProvenanceLegend({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 text-[10px] text-muted-foreground ${className}`} data-testid="prov-legend">
      {Object.entries(MAP).map(([k, m]) => (
        <span key={k} className="inline-flex items-center gap-1">
          <ProvenanceBadge source={k} /> {m.label}
        </span>
      ))}
    </span>
  );
}
